import { useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { EnvelopeSimple, Check, ArrowRight, Sparkle } from "@phosphor-icons/react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { FREE_WORKSHEET_URL } from "@/data/storeLinks";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const NewsletterSection = () => {
  const [email, setEmail] = useState("");
  const [name, setName] = useState("");
  const [busy, setBusy] = useState(false);
  const [done, setDone] = useState(false);

  const subscribe = async (e) => {
    e.preventDefault();
    if (!email) return toast.error("Please enter your email address");
    setBusy(true);
    try {
      await axios.post(`${API}/newsletter/subscribe`, { email, name: name || undefined });
      toast.success("Welcome aboard! Check your inbox for your free worksheet.");
      setDone(true);
    } catch (err) {
      toast.error(err.response?.status === 400 ? "This email is already subscribed!" : "Oops! Something went wrong. Please try again.");
    } finally {
      setBusy(false);
    }
  };

  return (
    <section id="newsletter" className="py-14 sm:py-20 px-4 scroll-mt-28" aria-labelledby="newsletter-title">
      <div className="max-w-3xl mx-auto bg-[#f2effb] border border-[#d9d0ef] rounded-3xl p-7 sm:p-12 text-center">
        {done ? (
          <div data-testid="freebie-success">
            <div className="w-16 h-16 bg-primary rounded-full flex items-center justify-center mx-auto mb-5"><Check size={32} weight="bold" className="text-white" /></div>
            <h2 className="font-nunito font-extrabold tracking-tight text-3xl text-[#17284b] mb-3">You're in! 🎉</h2>
            <p className="font-nunito text-[#596882] mb-6">Click below to get your free worksheet (opens on TpT — it's free).</p>
            <a href={FREE_WORKSHEET_URL} target="_blank" rel="noopener noreferrer" data-testid="download-freebie-btn">
              <Button className="bg-[#0f285f] hover:bg-[#15367a] text-white font-nunito font-bold border border-[#d4dff0] rounded-xl px-7 py-5">
                Download Free Worksheet <ArrowRight size={18} weight="bold" className="ml-2" />
              </Button>
            </a>
          </div>
        ) : (
          <>
            <EnvelopeSimple size={44} weight="duotone" className="text-[#7358b3] mx-auto mb-3" />
            <h2 id="newsletter-title" className="font-nunito font-extrabold tracking-tight text-3xl sm:text-4xl text-[#17284b] mb-3">Get Your Free Worksheet</h2>
            <p className="font-nunito text-[#596882] mb-7 max-w-lg mx-auto">
              Subscribe for a <span className="font-bold text-[#17284b]">free Context Clues Tracing Worksheet</span>, gentle teaching tips, and new-resource news.
            </p>
            <form onSubmit={subscribe} className="space-y-3 max-w-md mx-auto">
              <Input type="text" placeholder="Your name (optional)" value={name} onChange={(e) => setName(e.target.value)} className="font-nunito border border-[#d4dff0] rounded-xl py-5" data-testid="newsletter-name-input" aria-label="Your name" />
              <Input type="email" placeholder="Your email address" value={email} onChange={(e) => setEmail(e.target.value)} required className="font-nunito border border-[#d4dff0] rounded-xl py-5" data-testid="newsletter-email-input" aria-label="Your email address" />
              <Button type="submit" disabled={busy} className="w-full bg-[#0f285f] hover:bg-[#15367a] text-white font-nunito font-bold text-base border border-[#d4dff0] rounded-xl py-6" data-testid="newsletter-submit-btn">
                {busy ? "Subscribing…" : (<><Sparkle size={20} weight="fill" className="mr-2" />Get My Free Worksheet</>)}
              </Button>
            </form>
          </>
        )}
      </div>
    </section>
  );
};
